import { render, staticRenderFns } from "./home_Tab_article.vue?vue&type=template&id=333c6f39&scoped=true&"
import script from "./home_Tab_article.vue?vue&type=script&lang=js&"
export * from "./home_Tab_article.vue?vue&type=script&lang=js&"
import style0 from "./home_Tab_article.vue?vue&type=style&index=0&id=333c6f39&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333c6f39",
  null
  
)

export default component.exports